<template>
  <div>
    <h4>Tesorería</h4>
    <h5>Cuentas</h5>
    <router-link to="/admin/tesoreria/saldos">
    <button type="button" class="btn btn-primary">Saldos de familias</button>
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'AdminTesoreria',
}
</script>
